import Vue from 'vue'
import VConsole from 'vconsole'
import App from './App'
import router from './router'
import store from './store'
import './icons' // icon
import mixins from '@/mixins'
// import vueFilePreview from 'gxd-file-preview';
import 'vant/lib/index.less'
import './assets/font/iconfont.css'
import '@/common/style/global.scss'
import '@/utils/permission'
import '@/utils/updateTitle'
import 'lib-flexible/flexible'
import components from '@/components/components'
import { Overlay, ImagePreview } from 'vant-green'
import '@/registerComponts'
import toast from '@/utils/toast'
import handleClipboard from '@/utils/clipboard'
import '@/directive'
import ContinuousClickCall from '@/utils/continuousClickCall'
import VanFieldSelectPicker from '@/components/Select'
import previewFile from '@/components/office/preview'

Vue.use(ImagePreview)
// import {
//   Performance,
//   axiosReport,
//   defaultReport,
//   fetchReport,
//   jqueryReport,
//   noneReport
// } from 'web-report'
//
// Performance({
//   domain:'http://127.0.0.1:7001/api/v1/report/web',
//   add:{
//     appId:'daXhdPP1674107441613'
//   }
// })

Vue.config.productionTip = false

// 初始化自定义插件，（pdf.js,worker.js文件建议放在本地服务器),cdn有可能不稳定
// Vue.use(vueFilePreview,{
//   pdf: '@/utils/pdf.min.js', //pdf插件
//   worker:'@/utils/worker.min.js',//pdf.work插件
// });
Vue.use(VanFieldSelectPicker)
Vue.use(components)
Vue.use(Overlay)
Vue.component('PreviewFile', previewFile)
Vue.mixin(mixins)
Vue.prototype.$toast = toast
Vue.prototype.$copy = handleClipboard
Vue.prototype.$continuousClick = new ContinuousClickCall()
if (process.env.VUE_APP_ENV !== 'prod') {
  new VConsole()
}
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
